import { Paper } from "@mui/material";
import styled from "styled-components/macro";

import Menu from "./sidebar components/Menu";

const Wrapper = styled(Paper)`
  position: sticky;
  top: 0px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 10px;
  transition: 0.2s ease;
  overflow: hidden;
  border-radius: 0;
  min-height: calc(100vh - 74px);
  box-shadow: 0px 4px 14px 0px rgba(35, 37, 38, 0.15);
`;

export default function Sidebar({
  sidebarState,
  onMouseEnter,
  onMouseLeave,
  selectedMenu,
  setSelectedMenu,
}) {
  return (
    <Wrapper
      elevation={2}
      style={{
        width: sidebarState.open ? "250px" : "80px",
        background: "#fff",
      }}
    >
      <Menu
        sidebarState={sidebarState}
        selectedMenu={selectedMenu}
        setSelectedMenu={setSelectedMenu}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </Wrapper>
  );
}
